import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  "data-setup": "",
  class: "bg-white rounded-2xl border border-gray-200 p-5"
}
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2" }
const _hoisted_3 = ["data-pace", "aria-pressed", "onClick"]
const _hoisted_4 = { class: "block text-sm font-bold text-gray-900" }
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2" }
const _hoisted_6 = ["data-budget", "aria-pressed", "onClick"]
const _hoisted_7 = { class: "block text-sm font-bold text-gray-900" }
const _hoisted_8 = { class: "text-xs text-gray-500 mt-4" }
const _hoisted_9 = { class: "mt-4 flex items-center gap-3" }

import { ref } from 'vue'
import { RouterLink } from 'vue-router'

import NeueButton from '@/components/neue/NeueButton.vue'

import { BUDGET_CARDS, PACE_CARDS } from './marketingSeries'


export default {
  __name: 'MarketingSetup',
  props: {
  busy: { type: Boolean, default: false },
  sendWindow: { type: Object, default: () => ({ start: 10, end: 18, cap: 250 }) }
},
  emits: ['create'],
  setup(__props, { emit: __emit }) {


const emit = __emit
const pace = ref('full')
const budget = ref('$$')

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm font-bold text-gray-900" }, "How hard should it push?", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PACE_CARDS), (c) => {
        return (_openBlock(), _createElementBlock("button", {
          key: c.value,
          type: "button",
          "data-pace": c.value,
          "aria-pressed": pace.value === c.value,
          class: _normalizeClass(["text-left rounded-xl border p-3 text-xs text-gray-600", pace.value === c.value ? 'border-gray-900 ring-2 ring-gray-900 ring-inset' : 'border-gray-200']),
          onClick: $event => (pace.value = c.value)
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(c.title), 1),
          _createTextVNode(" " + _toDisplayString(c.text), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-sm font-bold text-gray-900 mt-5" }, "Monthly budget for offers and sends", -1)),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BUDGET_CARDS), (c) => {
        return (_openBlock(), _createElementBlock("button", {
          key: c.value,
          type: "button",
          "data-budget": c.value,
          "aria-pressed": budget.value === c.value,
          class: _normalizeClass(["text-left rounded-xl border p-3 text-xs text-gray-600", budget.value === c.value ? 'border-gray-900 ring-2 ring-gray-900 ring-inset' : 'border-gray-200']),
          onClick: $event => (budget.value = c.value)
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(c.title), 1),
          _createTextVNode(" " + _toDisplayString(c.text), 1)
        ], 10, _hoisted_6))
      }), 128))
    ]),
    _createElementVNode("p", _hoisted_8, [
      _createTextVNode(" Texts go " + _toDisplayString(__props.sendWindow.start) + ":00 to " + _toDisplayString(__props.sendWindow.end) + ":00 your time, at most " + _toDisplayString(__props.sendWindow.cap) + " a day. Brand voice comes from your ", 1),
      _createVNode(_unref(RouterLink), {
        to: "/ai/agents/settings",
        class: "underline"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("AI agent settings", -1)
        ]))]),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createTextVNode(". Change any of this later. ", -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(NeueButton, {
        "data-create": "",
        loading: __props.busy,
        disabled: __props.busy,
        onClick: _cache[0] || (_cache[0] = $event => (emit('create', { pace: pace.value, budget_tier: budget.value })))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Turn it on ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "First plan lands in about a minute.", -1))
    ])
  ]))
}
}

}